import { render, staticRenderFns } from "./RoutineHeader.vue?vue&type=template&id=5073cf26&scoped=true&"
import script from "./RoutineHeader.vue?vue&type=script&lang=ts&"
export * from "./RoutineHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RoutineHeader.vue?vue&type=style&index=0&id=5073cf26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073cf26",
  null
  
)

export default component.exports